<template>
  <section
    class="grid grid-cols-12 container mx-auto w-100 sm:w-8/12 lg:w-8/12 xl:w-8/12 p-5 md:py-48 py-8"
    v-motion
    :initial="initialMotion"
    :enter="enterMotion"
  >
    <div
      class="col-span-12 sm:col-span-12 lg:col-span-4 xl:col-span-4 mb-10 flex justify-center"
    >
      <img
        :src="alertStore?.currentMessageField?.homeroAvatar"
        class="w-100 sm:h-64 h-48 mr-5 bg-transparent rounded-full"
        alt="avatar-image"
        loading="lazy"
      />
    </div>

    <div class="col-span-12 sm:col-span-12 lg:col-span-8 xl:col-span-8">
      <div
        class="w-[100%] min-w-[280px] min-h-[250px] bg-white rounded-md p-8 flex flex-col gap-2"
      >
        <div class="flex justify-start sm:flex-row flex-col gap-3">
          <div class="flex flex-row space-x-3 w-[91%]">
            <img
              class="w-[3%] min-w-[20px]"
              :src="alertStore?.currentMessageField?.iconTitle"
              alt="icon title"
              loading="lazy"
            />
            <h4 class="text-h-primary-500 capitalize">
              {{ alertStore?.currentMessageField?.bigTitle }}
            </h4>
          </div>
          <div class="flex w-[15%] flex-row">
            <MessageVoice
              :msg="
                alertStore?.currentMessageField?.title +
                '.' +
                alertStore?.currentMessageField?.message
              "
              v-if="alertStore?.currentMessageField?.title"
              :showIconsName="false"
            />
          </div>
        </div>
        <div class="min-h-[150px] flex justify-center space-y-3 flex-col">
          <p class="font-[800] mt-3 sm:text-[16px] text-[12px]">
            {{ alertStore?.currentMessageField?.title }}
          </p>
          <p class="sm:text-[16px] text-[14px]">
            {{ alertStore?.currentMessageField?.message }}
          </p>
        </div>
      </div>
      <div
        class="mt-8"
        v-for="(button, i) in alertStore?.currentMessageField?.buttons"
        :key="i"
      >
        <Button :class="`w-full ${button.color}`" @click="button.action">
          {{ button.name }}
        </Button>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { MotionEnter, MotionInitial, MotionTransition } from "@/models/motion.model";
import { useAlertStore } from "@/store/adaptative/alert";
import { defineComponent } from "vue";
export default defineComponent({

  data() {
    return {
      bigTitle: "" as string,
      title: "" as string,
      message: "" as string,
      homeroAvatar: "" as string,
      iconTitle: "" as string,
      buttons: [] as any,
      loader: false as boolean,
      initialMotion: new MotionInitial(),
      enterMotion: new MotionEnter(1, 0, 0, new MotionTransition(40)),
      alertStore: useAlertStore,
    };
  },
});
</script>
